module.exports = __webpack_public_path__ + "static/media/11.e1cb245a.png";